// components/Points/PointHistory.jsx

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, List } from '@mui/material';
import PointLogItem from './PointLogItem';  // ✅ import

const PointHistory = () => {
  const [histories, setHistories] = useState([]);

  useEffect(() => {
    axios.get('/api/points/history/', { withCredentials: true })
      .then(res => setHistories(res.data.histories))
      .catch(err => console.error("포인트 내역 불러오기 실패:", err));
  }, []);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>📜 포인트 내역</Typography>
      <List>
        {histories.length > 0 ? (
          histories.map((log, index) => (
            <PointLogItem key={index} log={log} />
          ))
        ) : (
          <Typography>포인트 내역이 없습니다.</Typography>
        )}
      </List>
    </Box>
  );
};

export default PointHistory;
